import React from "react"

import { styled } from "@mui/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { ActionIcon, MuiIcon, Tooltip } from "@cirrus/ui-kit-ts"

import { IComment } from "../types/IComment"

interface IProps<T extends IComment<T, TMention, TRole>, TMention, TRole> extends IComment<T, TMention, TRole> {
  toggleLike: (id: string) => void
}

export const LikeCounter = <T extends IComment<T, TMention, TRole>, TMention, TRole>(comment: IProps<T, TMention, TRole>) => {
  const { i18n } = useTranslations()

  const likedBy = (comment.likedBy || [])
    .map((item) => item.title)
    .join(", ")

  return <Tooltip title={likedBy
    ? `${likedBy} ${i18n("General:LikedBy")}`
    : ""}>

    <Wrapper>
      <ActionIcon
        icon={comment.likedByCurrentUser
          ? MuiIcon.ThumbUp
          : MuiIcon.ThumbUpOutlined}
        color={comment.likedByCurrentUser ? "success" : "inherit"}
        onClick={() => comment.toggleLike(comment.id)} />

      {
        !!comment.likesCount
        && <Counter>({comment.likesCount})</Counter>
      }
    </Wrapper>
  </Tooltip>
}

const Counter = styled("div")({
  fontSize: "14px",
  color: "#737373",
  lineHeight: "18px"
})

const Wrapper = styled("div")({
  display: "flex",
  gap: "2px"
})
